'use client';

import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useStore } from '@/store/store';
import { GameLauncherEvents } from './constants';
import { isMessageFromEmbeddedIframe } from '@/utils/message-broker/embedded-iframe-message';
import { isAllowedGameMessageOrigin } from '@/utils/message-broker/allowed-origins';

export const useGameLauncherEvents = ({ triggerEntryCall, fetchRewardsMachineContent }: any) => {
    const router = useRouter();
    const closeEmbeddedGame = useStore((s) => s.embeddedGame.close);
    const isEmbeddedGameOpen = useStore((s) => s.embeddedGame.isOpen);
    const wasEmbeddedGameOpen = useRef(isEmbeddedGameOpen);

    useEffect(() => {
        if (wasEmbeddedGameOpen.current && !isEmbeddedGameOpen) {
            fetchRewardsMachineContent?.();
        }

        wasEmbeddedGameOpen.current = isEmbeddedGameOpen;
    }, [fetchRewardsMachineContent, isEmbeddedGameOpen]);

    useEffect(() => {
        const messageHandler = (event: any) => {
            if (!isAllowedGameMessageOrigin(event?.origin)) {
                return;
            }

            switch (event?.data?.type) {
                case GameLauncherEvents.IncentiveGameRedirect:
                    router.push(event.data.payload);
                    break;
                case GameLauncherEvents.IncentiveGameUpdate:
                case GameLauncherEvents.ReloadSpins:
                    triggerEntryCall?.();
                    break;
                case GameLauncherEvents.GameClosed:
                case GameLauncherEvents.GameLauncherClose:
                    if (isMessageFromEmbeddedIframe(event)) {
                        closeEmbeddedGame();
                        return;
                    }
                    fetchRewardsMachineContent?.();
                    break;
                default:
                    break;
            }
        };

        window.addEventListener('message', messageHandler);

        return () => window.removeEventListener('message', messageHandler);
    }, [closeEmbeddedGame, fetchRewardsMachineContent, router, triggerEntryCall]);
};
